/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/__root'
import { Route as AppRouteRouteImport } from './pages/_app/route'
import { Route as ChangePasswordRouteImport } from './pages/change-password'
import { Route as AppIndexRouteImport } from './pages/_app/index'
import { Route as AppProfileRouteImport } from './pages/_app/profile'
import { Route as AuthForgotPasswordRouteImport } from './pages/_auth/forgot-password'
import { Route as AuthSignInRouteImport } from './pages/_auth/sign-in'
import { Route as AppArtistsIndexRouteImport } from './pages/_app/artists/index'
import { Route as AppArtistsCreateRouteImport } from './pages/_app/artists/create'
import { Route as AppSetlistsIndexRouteImport } from './pages/_app/setlists/index'
import { Route as AppSetlistsCreateRouteImport } from './pages/_app/setlists/create'
import { Route as AppSongsIndexRouteImport } from './pages/_app/songs/index'
import { Route as AppSongsCreateRouteImport } from './pages/_app/songs/create'
import { Route as AppUsersIndexRouteImport } from './pages/_app/users/index'
import { Route as AppUsersCreateRouteImport } from './pages/_app/users/create'
import { Route as AppArtistsIdIndexRouteImport } from './pages/_app/artists/$id/index'
import { Route as AppSetlistsIdIndexRouteImport } from './pages/_app/setlists/$id/index'
import { Route as AppSetlistsIdPrintRouteImport } from './pages/_app/setlists/$id/print'
import { Route as AppSetlistsIdViewRouteImport } from './pages/_app/setlists/$id/view'
import { Route as AppSongsIdIndexRouteImport } from './pages/_app/songs/$id/index'
import { Route as AppSongsIdPrintRouteImport } from './pages/_app/songs/$id/print'
import { Route as AppSongsIdViewRouteImport } from './pages/_app/songs/$id/view'
import { Route as AppUsersIdIndexRouteImport } from './pages/_app/users/$id/index'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/_auth/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/_auth/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AppArtistsIndexRoute = AppArtistsIndexRouteImport.update({
  id: '/artists/',
  path: '/artists/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppArtistsCreateRoute = AppArtistsCreateRouteImport.update({
  id: '/artists/create',
  path: '/artists/create',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSetlistsIndexRoute = AppSetlistsIndexRouteImport.update({
  id: '/setlists/',
  path: '/setlists/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSetlistsCreateRoute = AppSetlistsCreateRouteImport.update({
  id: '/setlists/create',
  path: '/setlists/create',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSongsIndexRoute = AppSongsIndexRouteImport.update({
  id: '/songs/',
  path: '/songs/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSongsCreateRoute = AppSongsCreateRouteImport.update({
  id: '/songs/create',
  path: '/songs/create',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppUsersCreateRoute = AppUsersCreateRouteImport.update({
  id: '/users/create',
  path: '/users/create',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppArtistsIdIndexRoute = AppArtistsIdIndexRouteImport.update({
  id: '/artists/$id/',
  path: '/artists/$id/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSetlistsIdIndexRoute = AppSetlistsIdIndexRouteImport.update({
  id: '/setlists/$id/',
  path: '/setlists/$id/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSetlistsIdPrintRoute = AppSetlistsIdPrintRouteImport.update({
  id: '/setlists/$id/print',
  path: '/setlists/$id/print',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSetlistsIdViewRoute = AppSetlistsIdViewRouteImport.update({
  id: '/setlists/$id/view',
  path: '/setlists/$id/view',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSongsIdIndexRoute = AppSongsIdIndexRouteImport.update({
  id: '/songs/$id/',
  path: '/songs/$id/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSongsIdPrintRoute = AppSongsIdPrintRouteImport.update({
  id: '/songs/$id/print',
  path: '/songs/$id/print',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSongsIdViewRoute = AppSongsIdViewRouteImport.update({
  id: '/songs/$id/view',
  path: '/songs/$id/view',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppUsersIdIndexRoute = AppUsersIdIndexRouteImport.update({
  id: '/users/$id/',
  path: '/users/$id/',
  getParentRoute: () => AppRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/profile': typeof AppProfileRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/artists/create': typeof AppArtistsCreateRoute
  '/setlists/create': typeof AppSetlistsCreateRoute
  '/songs/create': typeof AppSongsCreateRoute
  '/users/create': typeof AppUsersCreateRoute
  '/artists/': typeof AppArtistsIndexRoute
  '/setlists/': typeof AppSetlistsIndexRoute
  '/songs/': typeof AppSongsIndexRoute
  '/users/': typeof AppUsersIndexRoute
  '/setlists/$id/print': typeof AppSetlistsIdPrintRoute
  '/setlists/$id/view': typeof AppSetlistsIdViewRoute
  '/songs/$id/print': typeof AppSongsIdPrintRoute
  '/songs/$id/view': typeof AppSongsIdViewRoute
  '/artists/$id/': typeof AppArtistsIdIndexRoute
  '/setlists/$id/': typeof AppSetlistsIdIndexRoute
  '/songs/$id/': typeof AppSongsIdIndexRoute
  '/users/$id/': typeof AppUsersIdIndexRoute
}
export interface FileRoutesByTo {
  '/change-password': typeof ChangePasswordRoute
  '/profile': typeof AppProfileRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/': typeof AppIndexRoute
  '/artists/create': typeof AppArtistsCreateRoute
  '/setlists/create': typeof AppSetlistsCreateRoute
  '/songs/create': typeof AppSongsCreateRoute
  '/users/create': typeof AppUsersCreateRoute
  '/artists': typeof AppArtistsIndexRoute
  '/setlists': typeof AppSetlistsIndexRoute
  '/songs': typeof AppSongsIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/setlists/$id/print': typeof AppSetlistsIdPrintRoute
  '/setlists/$id/view': typeof AppSetlistsIdViewRoute
  '/songs/$id/print': typeof AppSongsIdPrintRoute
  '/songs/$id/view': typeof AppSongsIdViewRoute
  '/artists/$id': typeof AppArtistsIdIndexRoute
  '/setlists/$id': typeof AppSetlistsIdIndexRoute
  '/songs/$id': typeof AppSongsIdIndexRoute
  '/users/$id': typeof AppUsersIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/_app/profile': typeof AppProfileRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_app/': typeof AppIndexRoute
  '/_app/artists/create': typeof AppArtistsCreateRoute
  '/_app/setlists/create': typeof AppSetlistsCreateRoute
  '/_app/songs/create': typeof AppSongsCreateRoute
  '/_app/users/create': typeof AppUsersCreateRoute
  '/_app/artists/': typeof AppArtistsIndexRoute
  '/_app/setlists/': typeof AppSetlistsIndexRoute
  '/_app/songs/': typeof AppSongsIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/setlists/$id/print': typeof AppSetlistsIdPrintRoute
  '/_app/setlists/$id/view': typeof AppSetlistsIdViewRoute
  '/_app/songs/$id/print': typeof AppSongsIdPrintRoute
  '/_app/songs/$id/view': typeof AppSongsIdViewRoute
  '/_app/artists/$id/': typeof AppArtistsIdIndexRoute
  '/_app/setlists/$id/': typeof AppSetlistsIdIndexRoute
  '/_app/songs/$id/': typeof AppSongsIdIndexRoute
  '/_app/users/$id/': typeof AppUsersIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/change-password'
    | '/profile'
    | '/forgot-password'
    | '/sign-in'
    | '/artists/create'
    | '/setlists/create'
    | '/songs/create'
    | '/users/create'
    | '/artists/'
    | '/setlists/'
    | '/songs/'
    | '/users/'
    | '/setlists/$id/print'
    | '/setlists/$id/view'
    | '/songs/$id/print'
    | '/songs/$id/view'
    | '/artists/$id/'
    | '/setlists/$id/'
    | '/songs/$id/'
    | '/users/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/change-password'
    | '/profile'
    | '/forgot-password'
    | '/sign-in'
    | '/'
    | '/artists/create'
    | '/setlists/create'
    | '/songs/create'
    | '/users/create'
    | '/artists'
    | '/setlists'
    | '/songs'
    | '/users'
    | '/setlists/$id/print'
    | '/setlists/$id/view'
    | '/songs/$id/print'
    | '/songs/$id/view'
    | '/artists/$id'
    | '/setlists/$id'
    | '/songs/$id'
    | '/users/$id'
  id:
    | '__root__'
    | '/_app'
    | '/change-password'
    | '/_app/profile'
    | '/_auth/forgot-password'
    | '/_auth/sign-in'
    | '/_app/'
    | '/_app/artists/create'
    | '/_app/setlists/create'
    | '/_app/songs/create'
    | '/_app/users/create'
    | '/_app/artists/'
    | '/_app/setlists/'
    | '/_app/songs/'
    | '/_app/users/'
    | '/_app/setlists/$id/print'
    | '/_app/setlists/$id/view'
    | '/_app/songs/$id/print'
    | '/_app/songs/$id/view'
    | '/_app/artists/$id/'
    | '/_app/setlists/$id/'
    | '/_app/songs/$id/'
    | '/_app/users/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/artists/': {
      id: '/_app/artists/'
      path: '/artists'
      fullPath: '/artists/'
      preLoaderRoute: typeof AppArtistsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/artists/create': {
      id: '/_app/artists/create'
      path: '/artists/create'
      fullPath: '/artists/create'
      preLoaderRoute: typeof AppArtistsCreateRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/setlists/': {
      id: '/_app/setlists/'
      path: '/setlists'
      fullPath: '/setlists/'
      preLoaderRoute: typeof AppSetlistsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/setlists/create': {
      id: '/_app/setlists/create'
      path: '/setlists/create'
      fullPath: '/setlists/create'
      preLoaderRoute: typeof AppSetlistsCreateRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/songs/': {
      id: '/_app/songs/'
      path: '/songs'
      fullPath: '/songs/'
      preLoaderRoute: typeof AppSongsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/songs/create': {
      id: '/_app/songs/create'
      path: '/songs/create'
      fullPath: '/songs/create'
      preLoaderRoute: typeof AppSongsCreateRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/users/create': {
      id: '/_app/users/create'
      path: '/users/create'
      fullPath: '/users/create'
      preLoaderRoute: typeof AppUsersCreateRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/artists/$id/': {
      id: '/_app/artists/$id/'
      path: '/artists/$id'
      fullPath: '/artists/$id/'
      preLoaderRoute: typeof AppArtistsIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/setlists/$id/': {
      id: '/_app/setlists/$id/'
      path: '/setlists/$id'
      fullPath: '/setlists/$id/'
      preLoaderRoute: typeof AppSetlistsIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/setlists/$id/print': {
      id: '/_app/setlists/$id/print'
      path: '/setlists/$id/print'
      fullPath: '/setlists/$id/print'
      preLoaderRoute: typeof AppSetlistsIdPrintRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/setlists/$id/view': {
      id: '/_app/setlists/$id/view'
      path: '/setlists/$id/view'
      fullPath: '/setlists/$id/view'
      preLoaderRoute: typeof AppSetlistsIdViewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/songs/$id/': {
      id: '/_app/songs/$id/'
      path: '/songs/$id'
      fullPath: '/songs/$id/'
      preLoaderRoute: typeof AppSongsIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/songs/$id/print': {
      id: '/_app/songs/$id/print'
      path: '/songs/$id/print'
      fullPath: '/songs/$id/print'
      preLoaderRoute: typeof AppSongsIdPrintRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/songs/$id/view': {
      id: '/_app/songs/$id/view'
      path: '/songs/$id/view'
      fullPath: '/songs/$id/view'
      preLoaderRoute: typeof AppSongsIdViewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/users/$id/': {
      id: '/_app/users/$id/'
      path: '/users/$id'
      fullPath: '/users/$id/'
      preLoaderRoute: typeof AppUsersIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppProfileRoute: typeof AppProfileRoute
  AppIndexRoute: typeof AppIndexRoute
  AppArtistsCreateRoute: typeof AppArtistsCreateRoute
  AppSetlistsCreateRoute: typeof AppSetlistsCreateRoute
  AppSongsCreateRoute: typeof AppSongsCreateRoute
  AppUsersCreateRoute: typeof AppUsersCreateRoute
  AppArtistsIndexRoute: typeof AppArtistsIndexRoute
  AppSetlistsIndexRoute: typeof AppSetlistsIndexRoute
  AppSongsIndexRoute: typeof AppSongsIndexRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
  AppSetlistsIdPrintRoute: typeof AppSetlistsIdPrintRoute
  AppSetlistsIdViewRoute: typeof AppSetlistsIdViewRoute
  AppSongsIdPrintRoute: typeof AppSongsIdPrintRoute
  AppSongsIdViewRoute: typeof AppSongsIdViewRoute
  AppArtistsIdIndexRoute: typeof AppArtistsIdIndexRoute
  AppSetlistsIdIndexRoute: typeof AppSetlistsIdIndexRoute
  AppSongsIdIndexRoute: typeof AppSongsIdIndexRoute
  AppUsersIdIndexRoute: typeof AppUsersIdIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppProfileRoute: AppProfileRoute,
  AppIndexRoute: AppIndexRoute,
  AppArtistsCreateRoute: AppArtistsCreateRoute,
  AppSetlistsCreateRoute: AppSetlistsCreateRoute,
  AppSongsCreateRoute: AppSongsCreateRoute,
  AppUsersCreateRoute: AppUsersCreateRoute,
  AppArtistsIndexRoute: AppArtistsIndexRoute,
  AppSetlistsIndexRoute: AppSetlistsIndexRoute,
  AppSongsIndexRoute: AppSongsIndexRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
  AppSetlistsIdPrintRoute: AppSetlistsIdPrintRoute,
  AppSetlistsIdViewRoute: AppSetlistsIdViewRoute,
  AppSongsIdPrintRoute: AppSongsIdPrintRoute,
  AppSongsIdViewRoute: AppSongsIdViewRoute,
  AppArtistsIdIndexRoute: AppArtistsIdIndexRoute,
  AppSetlistsIdIndexRoute: AppSetlistsIdIndexRoute,
  AppSongsIdIndexRoute: AppSongsIdIndexRoute,
  AppUsersIdIndexRoute: AppUsersIdIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
